import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import {
  Keys,
  TestDriver,
  TestElement,
  getTestDriver
} from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';

async function panStart(driver: TestDriver, element: TestElement): Promise<void> {
  await driver.click(element);
  await driver.sendKeys(element, Keys['PAGE_UP']);
}

async function panEnd(driver: TestDriver, element: TestElement): Promise<void> {
  await driver.click(element);
  await driver.sendKeys(element, Keys['PAGE_DOWN']);
}

async function clearPreviousSelection(element: TestElement) {
  const driver = getTestDriver();
  await driver.click(element);
}

// Function to find the data point by id
async function findDataPointById(itemId: string | number, element: TestElement) {
  const dataPointElements = await element.waitForElements(
    byCss(`[data-oj-private-item-id="${itemId}"]`)
  );
  // Check if any data points are found
  if (dataPointElements.length === 0) {
    return null;
  }
  return dataPointElements[0];
}

export class LineAreaChartAdapter extends TestAdapter {
  //TODO : We will need to remove selection mode when we can read attributes.
  /**
   * Triggers selection on the given item
   * @param itemId
   * @param replace
   * @param selectionMode
   */
  async doSelectItem(
    itemId: string | number,
    replace: boolean,
    selectionMode: string
  ): Promise<void> {
    const driver = getTestDriver();
    const chartElement = await this.getElement();

    if (selectionMode === 'single' || replace) {
      await clearPreviousSelection(chartElement);
    }
    const dataPoint = await findDataPointById(itemId, chartElement);

    if (dataPoint) {
      await driver.click(dataPoint);
    } else {
      console.warn(`Data point with itemId ${itemId} not found in the viewport`);
    }
  }

  // TODO: Perform CTRL+Click to implement de-select. 
  // async doDeselectItem(locator: TestIdLocator, itemId: string|number): Promise<void> {
  //   const chartElement = await getElement(locator);
  //   const driver = getTestDriver();

  //   // Find the data point with the given itemId
  //   const dataPoint = await findDataPointById(chartElement,itemId);

  //   // Perform Ctrl + click
  //   if (dataPoint) {
  //     //await driver.sendKeys(dataPoint,Key.CONTROL,'a');
  //   } else {
  //     console.warn(`Data point with itemId ${itemId} not found in the viewport.`);
  //   }
  // }

  /**
   * Triggers item drill on then item with given id.
   * @returns
   */
  async doDrillItem(itemId: string | number): Promise<void> {
    const driver = getTestDriver();
    const chartElement = await this.getElement();

    const dataPoint = await findDataPointById(itemId, chartElement);

    // Check if a data point was found
    if (dataPoint) {
      // single click to simulate the drill action
      await driver.click(dataPoint);
    } else {
      console.warn(`Data point with itemId ${itemId} not found in the viewport.`);
    }
  }

  async doDrillGroup(groupId: string): Promise<void> {
    const driver = getTestDriver();
    const chartElement = await this.getElement();

    // Locate the group elements with the matching data-oj-private-id
    const groupElements = await chartElement.waitForElements(
      byCss(`[data-oj-private-group-id="${groupId}"]`)
    );

    // Check if a group was found
    if (groupElements[0]) {
      // Perform a single click to simulate the drill action
      await driver.click(groupElements[0]);
    } else {
      console.warn(`Group with groupId ${groupId} not found in the viewport.`);
    }
  }

  async doZoom(direction: 'in' | 'out'): Promise<void> {
    const driver = getTestDriver();
    const chartElement = await this.getElement();
    await driver.sendKeys(chartElement, direction === 'in' ? '+' : '-');
  }

  async doPan(direction: 'start' | 'end'): Promise<void> {
    const driver = getTestDriver();
    const chartElement = await this.getElement();
    if (direction === 'start') {
      await panStart(driver, chartElement);
    } else {
      await panEnd(driver, chartElement);
    }
  }
}
